// API base URL — production hardcoded.
// In dev with Vite proxy, this still works (CORS enabled on backend).
export const API_BASE = 'https://api.ubm.berlin';
